import React, { useEffect, useState } from 'react';
import EditProfile from './EditProfile';
import Navbar from './Navbar';
import '../fonts.css';
import API_BASE_URL from '../api';

function Profile() {
  const [userData, setUserData] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [showDeleteModel, setShowDeleteModel] = useState(false);
  const [password, setPassword] = useState('');
  const [editedData, setEditedData] = useState({
    name: '',
    age: '',
    gender: '',
    location: '',
    personality_type: '',
  });

  const getAuthToken = () => localStorage.getItem('stack_access_token');

  // Fetch user profile data
  useEffect(() => {
    const token = getAuthToken();
    fetch(`${API_BASE_URL}/api/profile/`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Stack-Access-Token': token,
      },
    })
      .then((response) => response.json())
      .then((data) => setUserData(data))
      .catch((error) =>
        console.error('Failed to fetch profile details:', error),
      );
  }, []);

  // Fetch user profile picture
  useEffect(() => {
    const token = getAuthToken();
    fetch(`${API_BASE_URL}/api/profile/image`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Stack-Access-Token': token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.picture) {
          setUserData((prev) => ({ ...prev, picture: data.picture }));
        }
      })
      .catch((error) => console.error('Failed to fetch profile image:', error));
  }, []);

  const handleEditClick = () => {
    setEditMode(true);
    setEditedData(userData);
  };

  const handleEditProfileSave = async (e, editedData) => {
    e.preventDefault();
    try {
      const token = getAuthToken();
      const response = await fetch(`${API_BASE_URL}/api/profile/edit`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Stack-Access-Token': token,
        },
        body: JSON.stringify(editedData),
      });
      const updatedUserData = await response.json();
      setUserData(updatedUserData);
    } catch (err) {
      console.error('Failed to update profile', err);
    }
    setEditMode(false);
  };

  const handleEditProfileCancel = () => setEditMode(false);

  const handleDeleteProfile = async () => {
    try {
      const token = getAuthToken();
      const response = await fetch(`${API_BASE_URL}/api/profile/delete`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Stack-Access-Token': token,
        },
        body: JSON.stringify({ password }),
      });

      if (response.ok) {
        localStorage.removeItem('authToken');
        window.location.href = '/';
      } else {
        console.error('Failed to delete profile');
      }
    } catch (error) {
      console.error('Error deleting profile:', error);
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-[#0D2329]">
      <Navbar />

      <div className="flex-1 flex justify-center items-center p-6">
        {!editMode && userData ? (
          <div className="rounded-lg p-6 shadow-lg max-w-lg w-full text-white text-center bg-[#05664f]">
            {/* Profile Picture Circle (Clickable) */}
            <div className="relative flex justify-center mb-4">
              <label htmlFor="profilePictureInput" className="cursor-pointer">
                <img
                  src={
                    userData.picture && userData.picture.trim() !== ''
                      ? userData.picture
                      : 'https://via.placeholder.com/100'
                  }
                  alt="Profile"
                  className="w-24 h-24 rounded-full object-cover border-4 border-white hover:opacity-80 transition"
                />
              </label>
              <input type="file" id="profilePictureInput" className="hidden" />
            </div>

            {/* User Name and Personality Type */}
            <h1 className="text-3xl font-bold">{userData.name}</h1>
            <p className="text-lg text-gray-300">{userData.personality_type}</p>

            {/* Profile Details */}
            <div className="mt-4 text-left space-y-2">
              <p>
                <strong>Age:</strong> {userData.age}
              </p>
              <p>
                <strong>Gender:</strong> {userData.gender}
              </p>
              <p>
                <strong>Location:</strong> {userData.location}
              </p>
            </div>

            {/* Edit & Delete Buttons */}
            <div className="mt-6 flex justify-between">
              <button
                onClick={handleEditClick}
                className="py-2 px-4 rounded-md text-white font-medium bg-black"
              >
                EDIT PROFILE
              </button>

              <button
                onClick={() => setShowDeleteModel(true)}
                className="py-2 px-4 rounded-md text-white font-medium bg-red-600"
              >
                DELETE PROFILE
              </button>
            </div>
          </div>
        ) : editMode ? (
          <EditProfile
            onSave={handleEditProfileSave}
            onCancel={handleEditProfileCancel}
            initialData={editedData}
          />
        ) : (
          <p className="text-white">Loading profile data...</p>
        )}
      </div>

      {/* Delete Profile Model */}
      {showDeleteModel && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-[#05664f] p-6 rounded-lg shadow-lg text-white text-center">
            <h2 className="text-xl font-bold mb-4">Confirm Deletion</h2>
            <p>Enter your password to delete your profile:</p>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-3 p-2 w-full rounded-md text-black"
            />
            <div className="mt-4 flex justify-between">
              <button
                onClick={handleDeleteProfile}
                className="py-2 px-4 rounded-md bg-red-600 text-white"
              >
                DELETE
              </button>
              <button
                onClick={() => setShowDeleteModel(false)}
                className="py-2 px-4 rounded-md bg-black text-white"
              >
                CANCEL
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Profile;
